/* eslint-disable @typescript-eslint/no-explicit-any */

import { REACT_APP_VIVOCHAT_SRC_URL } from 'config';

export function injectVivochatScript() {
  const existingScript = document.querySelector(
    `script[src="${REACT_APP_VIVOCHAT_SRC_URL}"]`,
  );

  if (!existingScript) {
    (window as any).vvc_ready_handlers = [];
    (window as any).vivocha = {
      ready: function (cb: any) {
        (window as any).vvc_ready_handlers.push(cb);
      },
      setOptions: function (opts: any) {
        (window as any).vvc_options = opts;
      },
    };

    const vivoChatScript = document.createElement('script');
    vivoChatScript.type = 'text/javascript';
    vivoChatScript.async = true;
    vivoChatScript.src = REACT_APP_VIVOCHAT_SRC_URL;

    document.head.appendChild(vivoChatScript);
  }
}
